import { render } from "./PatientKins.vue?vue&type=template&id=5bc5fb1d&ts=true"
import script from "./PatientKins.vue?vue&type=script&lang=ts"
export * from "./PatientKins.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__